import axios from 'axios';
import Storage from "./storage";
import Router from '../routes';
import { useRootStore } from '../stores/root';

let isRefreshing = false;
let failedQueue = [];

function processQueue(error, token = null) {
    failedQueue.forEach(promise => {
        if (error) {
            return promise.reject(error);
        } else {
            return promise.resolve(token);
        }
    });

    failedQueue = [];
}

axios.defaults.headers['Content-Type'] = 'application/json';

axios.interceptors.request.use(config => {
    const token = Storage.getAccessToken();

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    
    const { websocket } = useRootStore();
    if (websocket) {
        const socketId = websocket.socketId();
        socketId && (config.headers['X-Socket-Id'] = socketId); 
    }

    return config;
}, error => Promise.reject(error));

axios.interceptors.response.use(
    response => response,
    error => {
        const originalRequest = error.config;
        const rootStore = useRootStore();

        if (error.response.status === 401 && !originalRequest._retry) {
            if (originalRequest.url === '/api/auth/refresh' && isRefreshing) {
                return Promise.reject(error);
            }

            if (isRefreshing) {
                return new Promise(function (resolve, reject) {
                    failedQueue.push({resolve, reject});
                })
                    .then(token => {
                        originalRequest.headers['Authorization'] = `Bearer ${token}`;
                        return axios(originalRequest);
                    })
                    .catch(error => {
                        return Promise.reject(error)
                    })
            }

            originalRequest._retry = true;
            isRefreshing = true;

            const data = {
                'refresh_token': Storage.getRefreshToken()
            };

            return new Promise(function (resolve, reject) {
                axios.post('/api/auth/refresh', data)
                    .then(({data}) => {
                        Storage.setAccessToken(data['access_token']);
                        Storage.setRefreshToken(data['refresh_token']);

                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + data['access_token'];
                        originalRequest.headers['Authorization'] = 'Bearer ' + data['access_token'];

                        processQueue(null, data['access_token']);
                        resolve(axios(originalRequest));
                    })
                    .catch((error) => {
                        processQueue(error, null);

                        rootStore.logout();

                        if (Router.app.$route.name !== 'login') {
                            Router.push({ name: 'login' }, null);
                        }

                        reject(error);
                    })
                    .then(() => {
                        isRefreshing = false;
                    });
            });
        }

        return Promise.reject(error);
    }
);

export default axios;
